


























import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import Card from '@c/Card.vue';
import ModuleDeveloperActionMixin from '@/mixins/ModuleDeveloperActionMixin';
import {PMActionType} from '@/views/system/modules/enums';
import {getFormattedDate} from '@/utils/dateTimeUtils';

@Component({
  components: {Card},
})
export default class StartRecordAction extends Mixins(ModuleDeveloperActionMixin) {
  // хранилище
  @Prop()
  apiStore!: any;

  duration = 3;

  error = false;
  loading = true;

  actionType = PMActionType.StartRecord;

  output: {timestamp: string; text: string}[] = [];

  async record() {
    this.error = false;
    this.loading = true;
    this.sendAction(async () => {
      try {
        await this.apiStore.startRecordAction({
          id: this.pmodule?.id as number,
          duration: this.duration,
        });
        this.output = [
          {
            timestamp: getFormattedDate(Date.now(), 'dd.MM.yyyy HH:mm:ss'),
            text: `Начало записи. Ширина полосы: ${this.duration} сек.`,
          },
        ];
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    });
  }

  @Watch('result')
  async onLoadResult(newVal: any) {
    if (!newVal) return;
    const strParse = JSON.parse(newVal);
    if (strParse) {
      const data = strParse.data;
      this.output.push({
        timestamp: getFormattedDate(strParse.timestamp, 'dd.MM.yyyy HH:mm:ss'),
        text: data.result,
      });
    }
  }
}
